export default {
    discount: null,
    discounts: [],
    contacts: [],
    lines: [],
    brands: [],
    params_contacts: {
        filter: "",
        type: "is_customer",
        paginate: false
    },
    params: {
        client: null,
        line: null,
        brand: null,
        percentage: null,
        perPage: 50,
        search: '',
        page: 1
    },
    loading: {
        module:false,
        download_report : false
    },

    message_loading : 'Cargando Plantilla De Incorporación De Clientes',
    file: '',
    upload_file: false
};



// WEBPACK FOOTER //
// ./src/modules/customerDiscountBrand/state.js